import React from 'react';
import ReactDOM from 'react-dom/client';

import Controller from './Controller';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";


import './css/main.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Controller />
        </BrowserRouter>
    </React.StrictMode>,
);

reportWebVitals();

